var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.4935,
    cy: 17.0759,
    rx: 16.4935,
    ry: 17.0759,
    fill: "#12B897"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.397 16.4977L17.4866 10.3768C17.8005 10.0943 18.2713 10.0943 18.5538 10.3768L19.2758 11.0987C19.5583 11.3812 19.5583 11.8521 19.2758 12.166L14.4418 17L19.2758 21.8653C19.5583 22.1792 19.5583 22.6501 19.2758 22.9326L18.5538 23.6545C18.2713 23.937 17.8005 23.937 17.4866 23.6545L11.397 17.5336C11.1145 17.2511 11.1145 16.7802 11.397 16.4977Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftOutlined);
export default __webpack_public_path__ + "static/media/leftOutlined.d540ef053f8126f73d47a543686c85bb.svg";
export { ForwardRef as ReactComponent };